module.exports = __webpack_public_path__ + "static/media/image_54.379e8a95.png";